import React from 'react';

import {Tooltip} from '@optimaxdev/design-system';

import s from './deliveryFormTooltip.scss';

/**
 * Delivery form tooltip for checkout delivery step
 *
 * @constructor
 */
export const DeliveryFormTooltip: React.FC = () => (
    <div className={s.tip}>
        <Tooltip
            content={
                <div className={s.tooltip}>
                    <p className={s.title}>Why we need your Phone number?</p>
                    <p className={s.content}>
                        Your phone number is required for sms status updates & delivery
                        confirmation.
                    </p>
                </div>
            }
            offset={0}
            position="bottom-end"
        >
            <span className={s.link}>Why?</span>
        </Tooltip>
    </div>
);
